import { LinearFilter } from "three";
import { useCounterStore } from "./stores/CounterStore";
import { Box, Html, PresentationControls, Sphere, useTexture } from "@react-three/drei";
import { useImageStore } from "./stores/ImageStore";
import TBC160_33 from "./TBC160-33";
import { useCamTargetStore } from "./stores/CamTargetStore";
import { TBC100 } from "./TBC100";
import { TBC110 } from "./TBC110";
import { TBC150 } from "./TBC150";
import { useColorStore } from "./stores/ColorStore";
import { TBC120 } from "./TBC120";
import { TBC180_50 } from "./TBC180-50";
import { useEffect, useState } from "react";
import { TBC180_100 } from "./TBC180-100";
import { TBC190 } from "./TBC190";
import { TBC191 } from "./TBC191";
import { TBC220 } from "./TBC220";
import { TBC225 } from "./TBC225";
import { TBC160_50 } from "./TBC160-50";
import { TBC169 } from "./TBC169";
import { TBC192 } from "./TBC192";
import { TBC184_40 } from "./TBC184-40";
import { TBC184_85 } from "./TBC184-85";

export default function ProductModel(props) {
    const content = useImageStore((state) => state.content)
    const assignCamId = useCounterStore((state) => state.assign)
    const camId = useCounterStore((state) => state.camTransformId)
    const setTargetPos = useCamTargetStore((state) => state.setTargetPosition)

    const assignBodyColor = useColorStore((state) => state.assignBody)
    const assignCapColor = useColorStore((state) => state.assignCap)

    const [isLabelVisible, setLabelVisibility] = useState()

    useEffect(() => {
        document.body.style.cursor = isLabelVisible ? 'pointer' : 'default'
    }, [isLabelVisible])

    const getModelComponent = (_modelId) => {
        switch (_modelId) {
            case "tbc160_33":
                return <TBC160_33
                    isBeingEdited={props.isBeingEdited}
                    materialSettings={props.materialSettings}
                    map={useTexture(content, (texture) => {
                        texture.flipY = false
                        texture.generateMipmaps = false
                        texture.minFilter = LinearFilter
                    })} />
            case "tbc160_50":
                return <TBC160_50
                    isBeingEdited={props.isBeingEdited}
                    materialSettings={props.materialSettings}
                    map={useTexture(content, (texture) => {
                        texture.flipY = false
                        texture.generateMipmaps = false
                        texture.minFilter = LinearFilter
                    })} />
            case "tbc169":
                return <TBC169
                    isBeingEdited={props.isBeingEdited}
                    materialSettings={props.materialSettings}
                    map={useTexture(content, (texture) => {
                        texture.flipY = false
                        texture.generateMipmaps = false
                        texture.minFilter = LinearFilter
                    })} />

            case "tbc100":
                return <TBC100
                    isBeingEdited={props.isBeingEdited}
                    materialSettings={props.materialSettings}
                    map={useTexture(content, (texture) => {
                        texture.flipY = false
                        texture.generateMipmaps = false
                        texture.minFilter = LinearFilter
                    })} />

            case "tbc110":
                return <TBC110
                    isBeingEdited={props.isBeingEdited}
                    materialSettings={props.materialSettings}
                    map={useTexture(content, (texture) => {
                        texture.flipY = false
                        texture.generateMipmaps = false
                        texture.minFilter = LinearFilter
                    })} />

            case "tbc120":
                return <TBC120
                    isBeingEdited={props.isBeingEdited}
                    materialSettings={props.materialSettings}
                    map={useTexture(content, (texture) => {
                        texture.flipY = false
                        texture.generateMipmaps = false
                        texture.minFilter = LinearFilter
                    })} />

            case "tbc150":
                return <TBC150
                    isBeingEdited={props.isBeingEdited}
                    materialSettings={props.materialSettings}
                    map={useTexture(content, (texture) => {
                        texture.flipY = false
                        texture.generateMipmaps = false
                        texture.minFilter = LinearFilter
                    })} />

            case "tbc220":
                return <TBC220
                    isBeingEdited={props.isBeingEdited}
                    materialSettings={props.materialSettings}
                    map={useTexture(content, (texture) => {
                        texture.flipY = false
                        texture.generateMipmaps = false
                        texture.minFilter = LinearFilter
                    })} />

            case "tbc225":
                return <TBC225
                    isBeingEdited={props.isBeingEdited}
                    materialSettings={props.materialSettings}
                    map={useTexture(content, (texture) => {
                        texture.flipY = false
                        texture.generateMipmaps = false
                        texture.minFilter = LinearFilter
                    })} />

            case "tbc180_50":
                return <TBC180_50
                    isBeingEdited={props.isBeingEdited}
                    materialSettings={props.materialSettings}
                    map={useTexture(content, (texture) => {
                        texture.flipY = false
                        texture.generateMipmaps = false
                        texture.minFilter = LinearFilter
                    })} />

            case "tbc180_100":
                return <TBC180_100
                    isBeingEdited={props.isBeingEdited}
                    materialSettings={props.materialSettings}
                    map={useTexture(content, (texture) => {
                        texture.flipY = false
                        texture.generateMipmaps = false
                        texture.minFilter = LinearFilter
                    })} />

            case "tbc184_40":
                return <TBC184_40
                    isBeingEdited={props.isBeingEdited}
                    materialSettings={props.materialSettings}
                    map={useTexture(content, (texture) => {
                        texture.flipY = false
                        texture.generateMipmaps = false
                        texture.minFilter = LinearFilter
                    })} />

            case "tbc184_85":
                return <TBC184_85
                    isBeingEdited={props.isBeingEdited}
                    materialSettings={props.materialSettings}
                    map={useTexture(content, (texture) => {
                        texture.flipY = false
                        texture.generateMipmaps = false
                        texture.minFilter = LinearFilter
                    })} />
        
            case "tbc190":
                return <TBC190
                    isBeingEdited={props.isBeingEdited}
                    materialSettings={props.materialSettings}
                    map={useTexture(content, (texture) => {
                        texture.flipY = false
                        texture.generateMipmaps = false
                        texture.minFilter = LinearFilter
                    })} />

            case "tbc191":
                return <TBC191
                    isBeingEdited={props.isBeingEdited}
                    materialSettings={props.materialSettings}
                    map={useTexture(content, (texture) => {
                        texture.flipY = false
                        texture.generateMipmaps = false
                        texture.minFilter = LinearFilter
                    })} />

            case "tbc192":
                return <TBC192
                    isBeingEdited={props.isBeingEdited}
                    materialSettings={props.materialSettings}
                    map={useTexture(content, (texture) => {
                        texture.flipY = false
                        texture.generateMipmaps = false
                        texture.minFilter = LinearFilter
                    })} />
        
            default:
                return "";
        }
    }

    return <group position={props.position}>
        {/* <ContactShadows position={props.position} opacity={1} scale={[3, 6]} blur={.5} far={5} /> */}
        <PresentationControls
            enabled={props.canRotate}
            global={false}
            speed={3}
            config={{ mass: 0, tension: 100 }}
            snap={false}
            rotation={[0, -4.14, 0]} // TODO - Fetch from model info db maybe?
            polar={[0, -Math.PI]}
        >
            {getModelComponent(props.modelId)}
            {(camId == 2 || camId == 7) ?
                <Box args={[.2, .2,.2]} position={[0, .12, 0]}
                    onPointerOver={(e) => {
                        e.stopPropagation()
                        setLabelVisibility(true)
                        setTimeout(() => setLabelVisibility(false), 7000)
                    }}
                    onPointerOut={() => setLabelVisibility(false)}
                    onClick={() => { // TODO - Move to currentSpot useEffect 
                        setTargetPos([props.position[0] + .3, props.position[1] + .122, props.position[2] - .065])
                        assignCamId(5)
                        // assignBodyColor("white")
                        // assignCapColor("white")
                        // console.log(props);
                        props.setCurrentSpot()
                    }}
                >
                    <meshBasicMaterial transparent={true} opacity={0} />
                </Box>
            : <></>
            }

        </PresentationControls>

        {(camId == 2 || camId == 7) && isLabelVisible?     // TODO - Change to prop and per-zone check
            <Html distanceFactor={10} >
                <div className={"annotationSmall"}
                    onClick={() => { // TODO - Move to currentSpot useEffect 
                        // setTargetPos([props.position[0] + .245, props.position[1] + .09, props.position[2] - .065])
                        // assignCamId(5)
                        // assignBodyColor("white")
                        // assignCapColor("white")
                        // props.setCurrentSpot()
                    }}
                >
                    {props.labelText} {/* TODO - Add buttonText field to db and replace labelText with it */}
                </div>
            </Html>
            : <></>
        }
    </group>
}